import PropTypes from 'prop-types';
import { FormGroup, Label, TextField } from '@celltrak/ui-components';
import noop from 'lodash/noop';

import { credentialForm } from '../../constants';

import styles from './EntityIdField.module.scss';

const EntityIdField = ({ value, onChange, disabled }) => {
  const handleValueChange = event => onChange(event);

  return (
    <div className={styles.entityIdField}>
      <FormGroup>
        <Label size="sm" for={credentialForm.entityIdId}>
          {credentialForm.entityIdLabel}
        </Label>
        <TextField
          id={credentialForm.entityIdId}
          size="sm"
          value={value}
          onChange={handleValueChange}
          disabled={disabled}
        />
      </FormGroup>
    </div>
  );
};

EntityIdField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

EntityIdField.defaultProps = {
  value: '',
  onChange: noop,
  disabled: false,
};

export default EntityIdField;
